module.exports = __webpack_public_path__ + "static/media/accordion_down.9e299a8e.svg";